module.exports = __webpack_public_path__ + "static/media/minus.a5645d8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/minus.svg
// module id = 1408
// module chunks = 0